<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('maintenances.breadcrumb_1')}}</router-link></li>
        <i v-if="userLang" class="fa-solid fa-chevron-left pt-1"></i>
        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="breadcrumb-item mx-3 almarai-bold" aria-current="page">{{$t('maintenances.breadcrumb_2')}}</li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <div v-if="isLoading" class="row justify-content-center">
          <div class="col text-center">
            <mainloader />
          </div>
        </div>
        <div class="row pt-5">
          <div class="col">
              <div class="text-center pb-3">
                <img src="/assets/images/icons/maintenance-logo.png" class="maintenanceLogo"  alt="">
              </div>
              <div class="row pt-3 justify-content-center">
                <div class="col-12 col-md-6">
                  <div class="card maintenanceCard" v-if="GET_USER">
                    <div class="card-body ">
                      <router-link to="/maintenanceslist">
                        <div class="row justify-content-center">
                          <div class="col">
                            <div class="almarai-bold">{{$t('maintenanceslist.breadcrumb_3')}}</div>
                            <span class="text-center almarai-regular text-style">{{$t('reliableMaintenance')}}</span>
                          </div>
                          <div class="col-auto content-center">
                            <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                            <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div v-else class="card maintenanceCard" @click="poupLogin">
                    <div class="card-body ">
                      <div class="row justify-content-center">
                        <div class="col">
                          <div class="almarai-bold">{{$t('maintenanceslist.breadcrumb_3')}}</div>
                          <span class="text-center almarai-regular text-style">{{$t('reliableMaintenance')}}</span>
                        </div>
                        <div class="col-auto content-center">
                          <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                          <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-3 justify-content-center">
                <div class="col-12 col-md-6">
                  <div class="card maintenanceCard" v-if="GET_USER">
                    <div class="card-body ">
                      <router-link to="/maintenances/?type=normal">
                        <div class="row justify-content-center">
                          <div class="col">
                            <div class="almarai-bold">{{$t('requestMaintenance')}}</div>
                            <span class="text-center almarai-regular text-style">{{$t('Within_24hours')}} {{ normalOrderPrice }} {{$t('addAd.real')}}</span>
                          </div>
                          <div class="col-auto content-center">
                            <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                            <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div v-else class="card maintenanceCard" @click="poupLogin">
                    <div class="card-body ">
                      <div class="row justify-content-center">
                        <div class="col">
                          <div class="almarai-bold">{{$t('requestMaintenance')}}</div>
                          <span class="text-center almarai-regular text-style">{{$t('Within_24hours')}} {{ normalOrderPrice }} {{$t('addAd.real')}}</span>
                        </div>
                        <div class="col-auto content-center">
                          <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                          <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt-3 justify-content-center">
                <div class="col-12 col-md-6">
                  <div class="card maintenanceCard" v-if="GET_USER">
                    <div class="card-body ">
                      <router-link to="/maintenances/?type=fast">
                        <div class="row justify-content-center">
                          <div class="col">
                            <div class="almarai-bold">{{$t('requestExpress_maintenance')}}</div>
                            <span class="text-center almarai-regular text-style">{{$t('Within_120Minutes')}} {{ fastOrderPrice }} {{$t('addAd.real')}}</span>
                          </div>
                          <div class="col-auto content-center">
                            <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                            <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div v-else class="card maintenanceCard" @click="poupLogin">
                    <div class="card-body ">
                      <div class="row justify-content-center">
                        <div class="col">
                          <div class="almarai-bold">{{$t('requestExpress_maintenance')}}</div>
                          <span class="text-center almarai-regular text-style">{{$t('Within_120Minutes')}} {{ fastOrderPrice }} {{$t('addAd.real')}}</span>
                        </div>
                        <div class="col-auto content-center">
                          <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                          <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt-3 justify-content-center">
                <div class="col-12 col-md-6">
                  <div class="card maintenanceCard" v-if="GET_USER">
                    <div class="card-body ">
                      <router-link to="/maintenances/?type=mosque">
                        <div class="row justify-content-center">
                          <div class="col">
                            <div class="almarai-bold">{{$t('maintenanceMosques')}}</div>
                            <span class="text-center almarai-regular text-style">{{$t('godsMosques')}}</span>
                          </div>
                          <div class="col-auto content-center">
                            <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                            <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div v-else class="card maintenanceCard" @click="poupLogin">
                    <div class="card-body ">
                      <div class="row justify-content-center">
                        <div class="col">
                          <div class="almarai-bold">{{$t('maintenanceMosques')}}</div>
                          <span class="text-center almarai-regular text-style">{{$t('godsMosques')}}</span>
                        </div>
                        <div class="col-auto content-center">
                          <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                          <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <!--begin:modal login-->
    <div class="modal bg-modal" dir="rtl" tabindex="-1" id="formLoginMainten">
      <div class="modal-dialog modal-Max320">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
                <div class="col-auto mouse-hand" @click.prevent="closeingFN">
                  <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col text-center">
                  <div class="loginTitle">
                    {{$t("formLogin.title_1")}}
                  </div>
                  <p class="fontGray-73 mb-1 pt-1">
                    {{$t("formLogin.title_2")}} <br />
                    {{$t("formLogin.title_3")}}
                  </p>
                </div>
              </div>
              <div class="row py-3 justify-content-center">
                <div class="col-10 col-md-8 mb-2">
                  <router-link to="/login">
                    <button
                      class="form-control btn-green"
                    >
                      {{$t("formLogin.title_4")}}
                    </button>
                  </router-link>
                </div>
                <div class="col-10 col-md-8 pt-1">
                  <router-link to="/register">
                    <button class="form-control btn-black">
                      {{ $t("formLogin.title_5") }}
                    </button>
                  </router-link>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal Login-->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "maintenance",
  data(){
    return{
      hasError: false,
      isLoading: true,
      message: "",
      errorNumber: "",
      userLang: 'ar',
      normalOrderPrice: 0,
      fastOrderPrice: 0,
    }
  },
  computed:{
    ...mapGetters(['GET_USER'])
  },
  methods:{
    getDatainitial(){
      this.hasError = false;
      this.$http.get("/api/orders/init").then(res => {
        // console.log(res);
        this.rows = res.data.issues;
        this.normalOrderPrice = res.data.normalOrderPrice;
        this.fastOrderPrice = res.data.fastOrderPrice;
        window.scroll(0,0);
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      });
    },
    poupLogin(){
      document.getElementById("formLoginMainten").style.display = "block";
    },
    closeingFN() {
      document.getElementById("formLoginMainten").style.display = "none";
    },
  },
  created(){
    this.getDatainitial();
    window.scroll(0,0);
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>